<dialog #dialog class="dialog" aria-labelledby="confirm-title" (cancel)="onEscape($event)">
  <h2 class="dialog__title" id="confirm-title">{{ title() }}</h2>
  <ng-content />
  <div class="button-row">
    <button
      class="button button--secondary"
      type="button"
      [disabled]="busy()"
      (click)="cancelled.emit()"
    >
      {{ cancelLabel() }}
    </button>
    <button
      class="button button--danger"
      type="button"
      [disabled]="busy()"
      (click)="confirmed.emit()"
    >
      {{ confirmLabel() }}
    </button>
  </div>
</dialog>
